import { Suspense, lazy } from "react";

const Platform = lazy(() => import("./PlatformSubscriptions").then((m) => ({ default: m.PlatformSubscriptions })));

// A tab of the Platform page: every organisation and the type it is on.
export const platformSubscriptionsTab = {
  key: "subscriptions",
  label: "Subscriptions",
  path: "/platform/subscriptions",
  after: "users",
  component: (props) => (
    <Suspense fallback={null}>
      <Platform {...props} />
    </Suspense>
  ),
};

const Mine = lazy(() => import("./OrgSubscription").then((m) => ({ default: m.OrgSubscription })));

// A tab of the Organization page: what the organisation is on, what each
// type includes, and asking for a change.
export const subscriptionTab = {
  key: "subscription",
  label: "Subscription",
  path: "/subscription",
  component: (props) => (
    <Suspense fallback={null}>
      <Mine {...props} />
    </Suspense>
  ),
  when: "manager",
  after: "payouts",
};
